import React from "react";
import {PropagateLoader} from "react-spinners";
const PageLoader = () => {
    return (
        <div className="preloader d-flex justify-content-center align-items-center" >
            <PropagateLoader color={'#74DE87FF'} />
        </div>

    )
}

export default PageLoader;